import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoadingService } from '../services/loading.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { NgClass, NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../services/http-service.service';

@Component({
  selector: 'app-reset-password',
  imports: [ ReactiveFormsModule, NgIf, NgClass, RouterLink],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  hide_show: boolean = false;
  confirm_hide_show : boolean = false;
  resetForm: FormGroup;
  logo : string | null = '';
  loadingService = inject(LoadingService);
  private httpService = inject(HttpServiceService);  
  resetQueryParamsSubscription : Subscription;
  resetPasswordSubscription : Subscription | undefined;
  private token : string = '';

  constructor(private fb: FormBuilder, private route : ActivatedRoute, private router: Router, private alertService: NgxToastrService){
    this.resetQueryParamsSubscription = this.route.paramMap.subscribe({
      next : (params) => {
        this.token = params.get('token') ?? "";
      }
    })
    this.resetForm = this.fb.group({      
      password : ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$(!%*?&)_-])[A-Za-z\d@$!(%*?&)-_]{6,}$/)]],
      confirmPassword : ['', [Validators.required]]      
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(){
    this.logo = this.httpService.getLogoUrl() ?? "";
  }

  passwordHide(){
    this.hide_show = !this.hide_show;
  }

  confirmPasswordHide(){
    this.confirm_hide_show = !this.confirm_hide_show;
  }

  passwordMatchValidator(control: AbstractControl) {
    const password = control?.get('password')?.value;
    const confirmPassword = control?.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit(){
    if (this.resetForm.valid) {
      let obj = {
        token : this.token,
        password : this.password?.value
      }      
      this.resetPasswordSubscription = this.httpService.resetPassword(obj).subscribe({
        next : (response) => {
          this.resetForm.reset();
          this.alertService.success(response.message, "toast-top-right");
          this.router.navigate(['/login']);
        },
        error : (error) => {

        }
      })
    }
  }

  get password() { return this.resetForm!.get('password'); }
  get confirmPassword() { return this.resetForm!.get('confirmPassword'); }

  ngOnDestroy() {
    this.resetQueryParamsSubscription.unsubscribe();
    this.resetPasswordSubscription?.unsubscribe();
  }

}
